import { useEffect, useRef, useState } from "react";
import axios from "axios";
import LearningVideoReview from "./LearningVideoReview";

const API = process.env.REACT_APP_BACKEND_URL || "";
export default function LearningVideoReviews() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  const [more, setMore] = useState(false);
  const generation = useRef(0);
  useEffect(() => () => { generation.current += 1; }, []);
  async function load() {
    const current = ++generation.current;
    setOpen(true); setError(""); setItems(null);
    try {
      const { data } = await axios.get(`${API}/api/media/external/learning-reviews`, { withCredentials: true, timeout: 20000 });
      if (current !== generation.current) return;
      if (!Array.isArray(data.items)) throw new Error("Invalid list");
      setItems(data.items); setMore(data.has_more === true);
    } catch {
      if (current === generation.current) setError("Your saved video reviews could not load. Retry when you are ready.");
    }
  }
  return <section className="my-4">
    <button type="button" onClick={open ? () => { generation.current += 1; setOpen(false); } : load} className="min-h-11 underline">{open ? "Close my video reviews" : "My video reviews"}</button>
    {open && <>
      {error ? <div role="alert"><p>{error}</p><button type="button" onClick={load} className="min-h-11 underline">Retry video reviews</button></div> : !items ? <p role="status">Loading saved review requests…</p> : <>
        {!items.length && <p>No video review requests are saved here yet.</p>}
        {items.map(item => <LearningVideoReview key={item.ndg_media_id} mediaId={item.ndg_media_id} savedReviewId={item.review_id} filename={item.filename} />)}
        {more && <p>Showing your latest 20 requests. Older requests are not included here.</p>}
      </>}
    </>}
  </section>;
}
